import { MInspector } from '@Models/client/inspection.model'
import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    // inspectors
    inspectors: [],
    inspectorsMetadata: {},
    inspectorQueries: {},
    inspectorLoading: false,

    // inspection schedule
    inspections: [],
    inspection: [],
    inspectionMetadata: {},
    inspectionQueries: {},
    inspectionLoading: false,
}

const InspectionReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        // inspector
        case ClientActionTypes.GET_INSPECTORS:
            return {
                ...state,
                ...action.payload,
            }

        case ClientActionTypes.SET_INSPECTOR_QUERIES:
            return {
                ...state,
                inspectorQueries: action.payload,
            }
        case ClientActionTypes.SET_INSPECTOR_LOADING:
            return {
                ...state,
                inspectorLoading: action.payload,
            }

        // inspection schedule
        case ClientActionTypes.GET_INSPECTION_SCHEDULES:
            return {
                ...state,
                ...action.payload,
            }
        case ClientActionTypes.GET_INSPECTION_SCHEDULE:
            return { ...state, inspection: action?.payload }
        case ClientActionTypes.SET_INSPECTION_SCHEDULE_LOADING:
            return { ...state, inspectionLoading: action.payload }
        default:
            return { ...state }
    }
}

export default InspectionReducer
